import { useEffect } from 'react';
import { useAuth } from '@core/hooks/useAuth';
import { useWishlistStore } from '@core/store/wishlistStore';

export default function FavoritesBootstrap() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    let cancelled = false;

    async function sync() {
      const store = useWishlistStore.getState();
      if (!isAuthenticated) {
        store.clear();
        return;
      }
      try {
        await store.syncFromServer();
      } catch {
        if (cancelled) return;
      }
    }

    sync();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated]);

  return null;
}
